import { supabase } from "./client";

export const supabaseStorageProvider = {
  /**
   * Sube un archivo a un bucket de Supabase.
   * @param {string} bucket - Nombre del bucket.
   * @param {string} path - Ruta del archivo dentro del bucket.
   * @param {File} file - El archivo a subir.
   */
  uploadFile: async (bucket, path, file, options = {}) => {
    return await supabase.storage.from(bucket).upload(path, file, {
      upsert: true,
      cacheControl: "3600",
      ...options,
    });
  },

  /**
   * Obtiene la URL pública de un archivo en un bucket de Supabase.
   * @param {string} bucket - Nombre del bucket.
   * @param {string} path - Ruta del archivo.
   */
  getPublicUrl: (bucket, path) => {
    const { data } = supabase.storage.from(bucket).getPublicUrl(path);
    return data?.publicUrl || null;
  },

  /**
   * Elimina un archivo en un bucket de Supabase.
   * @param {string} bucket - Nombre del bucket.
   * @param {string[]} paths - Lista de rutas de los archivos a eliminar.
   */
  deleteFiles: async (bucket, paths) => {
    return await supabase.storage.from(bucket).remove(paths);
  },

  /**
   * Lista archivos en un directorio de un bucket de Supabase.
   * @param {string} bucket - Nombre del bucket.
   * @param {string} path - Ruta del directorio.
   */
  listFiles: async (bucket, path) => {
    return await supabase.storage.from(bucket).list(path);
  },
};
